// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const DownArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="m8.5 1-4 3.5L1 1" stroke="#000" />
	</svg>
);
export default DownArrow;
